export const OPPORTUNITY_TEMPERATURES = ['cold', 'warm', 'hot'];

export const DEFAULT_OPPORTUNITY_TEMPERATURE = 'warm';

export const temperatureLabelKey = temperature =>
  `OPPORTUNITY_DETAILS.TEMPERATURE.OPTIONS.${String(
    temperature || DEFAULT_OPPORTUNITY_TEMPERATURE
  ).toUpperCase()}`;
